// src/Dashboard/pages/user/CalendarEvents/components/CalendarEventsToolbar.jsx

import React from "react";
import { FaFilter, FaHeart, FaSearch, FaTimes } from "react-icons/fa";

export default function CalendarEventsToolbar({
  ui,
  updateUi,
  debouncedSearch,
  setDebouncedSearch,
  typeOptions = [],
  categoryOptions = [],
  levelOptions = [],
  onReset,
}) {
  const fieldClass =
    "w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white";

  return (
    <div className="rounded-[24px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-900/60">
      <div className="mb-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 text-sm font-bold text-slate-900 dark:text-white">
            <FaFilter />
            Filtres calendrier
          </div>

          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
            Recherchez un événement ou filtrez par catégorie, type, niveau,
            statut et favoris.
          </p>
        </div>

        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() =>
              updateUi({
                favoriteOnly: !ui.favoriteOnly,
              })
            }
            className={`inline-flex items-center justify-center gap-2 rounded-2xl px-3 py-2 text-xs font-bold ring-1 transition ${
              ui.favoriteOnly
                ? "bg-rose-50 text-rose-700 ring-rose-200 dark:bg-rose-500/10 dark:text-rose-300 dark:ring-rose-500/20"
                : "bg-white text-slate-700 ring-slate-200 hover:bg-slate-50 dark:bg-slate-950 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-900"
            }`}
          >
            <FaHeart />
            Favoris
          </button>

          <button
            type="button"
            onClick={onReset}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-3 py-2 text-xs font-bold text-slate-700 ring-1 ring-slate-200 transition hover:bg-slate-50 dark:bg-slate-950 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-900"
          >
            <FaTimes />
            Réinitialiser
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Recherche
          </label>

          <div className="relative">
            <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

            <input
              type="text"
              value={debouncedSearch}
              onChange={(event) => setDebouncedSearch(event.target.value)}
              placeholder="Titre, lieu, description..."
              className="w-full rounded-2xl border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            />
          </div>
        </div>

        <div className="lg:col-span-2">
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Catégorie
          </label>

          <select
            value={ui.category}
            onChange={(event) =>
              updateUi({
                category: event.target.value,
              })
            }
            className={fieldClass}
          >
            <option value="all">Toutes</option>

            {categoryOptions.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>

        <div className="lg:col-span-2">
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Type
          </label>

          <select
            value={ui.type}
            onChange={(event) =>
              updateUi({
                type: event.target.value,
              })
            }
            className={fieldClass}
          >
            <option value="all">Tous</option>

            {typeOptions.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        <div className="lg:col-span-2">
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Niveau
          </label>

          <select
            value={ui.level}
            onChange={(event) =>
              updateUi({
                level: event.target.value,
              })
            }
            className={fieldClass}
          >
            <option value="all">Tous</option>

            {levelOptions.map((level) => (
              <option key={level} value={level}>
                {level}
              </option>
            ))}
          </select>
        </div>

        <div className="lg:col-span-2">
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Statut
          </label>

          <select
            value={ui.status}
            onChange={(event) =>
              updateUi({
                status: event.target.value,
              })
            }
            className={fieldClass}
          >
            <option value="all">Tous</option>
            <option value="upcoming">À venir</option>
            <option value="past">Passés</option>
          </select>
        </div>
      </div>

      <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Tri
          </label>

          <select
            value={ui.sort}
            onChange={(event) =>
              updateUi({
                sort: event.target.value,
              })
            }
            className={fieldClass}
          >
            <option value="dateAsc">Date croissante</option>
            <option value="dateDesc">Date décroissante</option>
            <option value="title">Titre A-Z</option>
          </select>
        </div>
      </div>
    </div>
  );
}